import { api } from './../function/api.js';
import { Media, Editor } from './../classes.js';
import { notification } from './../function/notification.js';
import { trigger_text_editor, trigger_sort, trigger_date_picker, start_loading, end_loading } from './../function/common.js';

//elements
import { text__element } from './../element/text.js';
import { image__element } from './../element/image.js';
import { video__element } from './../element/video.js';
import { youtube__element } from './../element/youtube.js';

export class cContent {
	constructor() {
		this.slug = '';
		this.edit = false;
		this.media = {};
		this.content = {
			'e': {}
		};
		
		$('body').on('click', '.content__menu--save', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.update(e.data.obj.slug);
		});
		
		$('body').on('click', '.content__menu--edit', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.manager_open();
		});
		
		$('body').on('click', '.content_manager--close', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.manager_close();
		})
		
		$('body').on('click', '#update_con', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.manager_update();
		});
		
	}
	
	async load(slug){;
		
		let content_request = new FormData();
		content_request.append('id', slug);
		
		try {
			let response = await fetch('/content/read', {
				method: 'POST',
				body: content_request
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			console.log(result);
			
			if(result.error){
				$('.content__main').html('<h2>Something went wrong. Try again later.</h2>');
			}else{
				//set the content
				this.set(result.data);
			}
			
		} catch (error) {
			console.log(error);
			$('.content__main').html('<h2>Something went really wrong. Try again later.</h2>');
		}
		
	}
	
	set(data){
		this.content = data.c;
		this.slug = data.c.slug;
		this.media = data.c.media;
		
		//**** LOAD MEDIA MANAGER
		Media.set_media(this.media);
		
		//***** SET SECONDARY DETAILS
		$('#con__form--description').val(this.content.description);
		if(this.content.media_id != null){
			$('#form__con').find('.content_gallery--open').data('set', this.content.media_id);
			$('#form__con').find('.media_id').val(this.content.media_id);
			$('#form__con').find('figure img').attr('src', this.media.files[this.content.media_id].path);
			$('#form__con').find('figure img').attr('alt', this.media.files[this.content.media_id].alt);
		}
		
		this.render();
	}
	
	render(){
		console.log('****** RENDERING CONTENT ******');
		let $block = $('<div/>', {
			'class': 'the_content',
			'data-block_id': 'content'
		});
		let $element;
		let response = `<div class="response"></div>`;
		let fields = {};
		$('.content__main').html('');
		
		//set basics
		$('#read_time').text(this.content.read_time);
		$('#word_count').text(this.content.word_count);
		
		if(typeof(this.content.e) != 'undefined'){
			//sort
			const sortedElements = Object.entries(this.content.e).sort((a, b) => a[1]['order'] - b[1]['order']);
			//display
			for (const [el_id, el] of sortedElements) {
				if(el.id != null){
					switch(el.type){
						case 'text':
							$element = text__element(el, this.edit);
							break;
						case 'image':
							$element = image__element(el, this.edit);
							break;
						case 'video':
							$element = video__element(el, this.edit);
							break;
						case 'youtube':
							$element = youtube__element(el, this.edit);
							break;
					}
					$block.append($element);
					
				}
			}
		}
		
		if(this.edit){
			$block.append(Editor.new_elements);
		}
		
		$('.content__main').append($block);
		
		//load editor view
		if(this.edit){
			trigger_text_editor();
			trigger_sort();
			
			Editor.render();
		}
	}
	
	
	async update(slug){
		start_loading('Saving');
		let f = document.querySelector('#content_form'); // an odd ID so it isn't guessed by someone random.
		let content_request = new FormData(f);
		content_request.append('id', slug);
		
		try {
			const allData = Object.fromEntries(content_request);
			console.log(allData); 
			
			let response = await fetch('/api/content/update', {
				method: 'POST',
				body: content_request
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			
			if(result.error){
				end_loading('Minor Issue... tell Josh');
				$('.content__main').html('<h2>Something minor went wrong. Tell Josh.</h2>');
			}else{
				//render the content
				end_loading('Success');
			}
			
		} catch (error) {
			end_loading('Major Issue... tell Josh');
			$('.content__main').html('<h2>Something went really wrong. Tell Josh.</h2>');
		}
		
	}
	
	manager_open(){
		$('#content_manager').css("display", "flex").hide().fadeIn(200);
	}
	
	manager_close(){
		$('#content_manager').fadeOut(200);
	}
	
	async manager_update(){
		//create the form to upload a file
		let f = document.querySelector('#form__con');
		let con_form = new FormData(f);
		
		//add the trip_id of our current focus
		con_form.append('content_id', this.content.id);
		console.log(Object.fromEntries(con_form));
		
		try {
			let response = await fetch('/api/content/manager-update', {
				method: 'POST',
				body: con_form
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			
			if(result.error){
				//error
				console.log(result);
			}else{
				this.manager_close();
				notification('Content settings updated');
			}
			
		} catch (error) {
			console.error('Error ***', error);
		}
	}
}